import cloneDeep from "lodash.clonedeep";
import { actions } from "./actions";
import { DEFAULT_STATE } from "./state";
import { mutationTypes, getterTypes } from "./types";

export default {
    actions,
    mutations: {
        [mutationTypes.adstxtValidationStart](state) {
            state.isLoading = true;
            state.data = null;
            state.error = null;
        },
        [mutationTypes.adstxtValidationSuccess](state, data) {
            state.isLoading = false;
            console.log("success", data);
            if (data.status) {
                state.status = data.status;
                state.statuses = data.statuses;
            } else {
                state.data = data;
            }
            console.log("updated state", state);
            state.error = null;
        },
        [mutationTypes.adstxtValidationFailure](state, error) {
            state.isLoading = false;
            state.error = error;
            state.data = null;
        },
    },
    getters: {
        [getterTypes.getAdstxtValidationResult](state) {
            return state.data;
        },
        [getterTypes.getAdstxtValidationStatus](state) {
            return state.status;
        },
        [getterTypes.getError](state) {
            return state.error;
        },
        [getterTypes.isLoading](state) {
            return state.isLoading;
        },
    },
    state: cloneDeep(DEFAULT_STATE),
};
